import { Accordion, AccordionDetails, AccordionSummary, Dialog, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from '@mui/icons-material/Menu';
import Langlist from "./LangList/LangList";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MAIN_MENU } from "../service/constants";
import { getConfig } from "../service/config";
import { useEffect, useState } from "react";
import { makeParams, getURLstring } from "../service/functions";

const ButtonRuEn = () => {
    const rus = useSelector(state => state.rus);
    const dispatch = useDispatch();
    const handleChangeUILanguage = () => {
        dispatch({ type: 'toggleRuEn', payload: (rus === 0) ? 1 : 0 });
    }

    return (
        <button className='mainmenubtn mainmenuruen' onClick={handleChangeUILanguage}>
            <span className={rus ? 'mainmenubtnactive' : ''}>RU</span>&nbsp;|&nbsp;<span className={rus ? '' : 'mainmenubtnactive'}>EN</span></button>
    )
}

const MainMenu = () => {
    const currentPage = useSelector(state => state.currentPage);
    const rus = useSelector(state => state.rus);
    const locallang = useSelector(state => state.locallang);
    const langGroup = useSelector(state => state.langGroup);
    const currentLang = useSelector(state => state.currentLang);
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        let lngs = getConfig().JSON_PATH + 'languages.json';
        fetch(lngs)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                setGroups(data);
                
                // Проверяем, есть ли в URL параметр group
                let params = makeParams();
                let targetGroup = data[0]; // по умолчанию первый элемент
                
                if (params.langGroup) {
                    // Ищем группу по script
                    const foundGroup = data.find(group => group.script === params.langGroup);
                    if (foundGroup) {
                        targetGroup = foundGroup;
                    }
                }
                
                dispatch({ type: 'setLangGroup', payload: targetGroup });
                dispatch({ type: 'switchLang', payload: targetGroup.local_default });
            })
            .catch(error => {
                console.error('MainMenu - error loading languages:', error);
            });
    }, []);


    const handleChangePancyrillic = () => {
        dispatch({ type: 'switchPage', payload: 1 });
    };

    const handleChangeLanguages = () => {
        dispatch({ type: 'switchPage', payload: 2 });
    };

    const handleChangeAbout = () => {
        dispatch({ type: 'switchPage', payload: 3 });
    };

    const handleChangeDefinitions = () => {
        dispatch({ type: 'switchPage', payload: 4 });
    };

    const handleChangeLangGroup = (newGroup) => {
        groups.forEach(ind => {
            if (ind.script === newGroup) {
                dispatch({ type: 'switchLang', payload: ind.local_default });
                dispatch({ type: 'setLangGroup', payload: ind });
                
                // Сбрасываем текущий язык при смене группы
                dispatch({ type: 'switchCurrentLang', payload: null });
                
                // Обновляем URL с новым group параметром, но без lang
                const newUrl = getURLstring(rus, null, currentPage, newGroup);
                window.history.pushState(null, null, newUrl);
            }
        })
    };

    return (<>
        <div className='wrap_topmenu'>
            <nav className='top_name'>{MAIN_MENU.logo[rus]}
                <select
                    onChange={e => {
                        handleChangeLangGroup(e.target.value);
                    }}
                    className='langgroupselect' name="lang_group_select">
                    <option value={langGroup?.script}>{rus ? langGroup?.name_rus : langGroup?.name_eng}</option>
                    {groups.map(item => {
                        if ((item.enable) && !(item.script === langGroup?.script))
                            return (<option key={item.script} value={item.script}>{rus ? item.name_rus : item.name_eng}</option>);
                    })}
                </select>
            </nav>
            <nav className='top_menu'>
                <p><button className={`mainmenubtn${currentPage == 3 ? ' mainmenubtnactive' : ''}`} onClick={handleChangeAbout}>{MAIN_MENU.about[rus]}</button></p>
                <p><button className={`mainmenubtn${currentPage == 2 ? ' mainmenubtnactive' : ''}`} onClick={handleChangeLanguages}>{MAIN_MENU.languages[rus]}</button></p>
                <p><button className={`mainmenubtn${currentPage == 1 ? ' mainmenubtnactive' : ''}`} onClick={handleChangePancyrillic}>{MAIN_MENU.panCyr[rus] + (rus ? langGroup?.name_rus : langGroup?.name_eng)}</button></p>
                <p><button className={`mainmenubtn${currentPage == 4 ? ' mainmenubtnactive' : ''}`} onClick={handleChangeDefinitions}>{MAIN_MENU.definitions[rus]}</button></p>
                <p><ButtonRuEn /></p>
            </nav>
        </div>
        <div className='wrap_mobmenu'>
            <Accordion sx={{ boxShadow: 0, p: 0, borderRadius: 0 }}>
                <AccordionSummary expandIcon={<MenuIcon sx={{ color: '#ffffff' }} />}
                    sx={{ p: 0, bgcolor: '#243235' }}>
                    <nav className="top_name_mobmenu"><div><span>{MAIN_MENU.logo[rus]}</span>
                        &nbsp;<select
                            onChange={e => {
                                handleChangeLangGroup(e.target.value);
                            }}
                            className='langgroupselect' name="lang_group_select">
                            <option value={langGroup?.script}>{rus ? langGroup?.name_rus : langGroup?.name_eng}</option>
                            {groups.map(item => {
                                if ((item.enable) && !(item.script === langGroup?.script))
                                    return (<option key={item.script} value={item.script}>{rus ? item.name_rus : item.name_eng}</option>);
                            })}
                        </select>
                    </div>
                        <ButtonRuEn />
                    </nav>
                </AccordionSummary>
                <AccordionDetails sx={{ p: '0 0 20px 0', bgcolor: '#243235' }}>
                    <p><button className={`mobmenubtn${currentPage == 3 ? ' mobmenubtnactive' : ''}`} onClick={handleChangeAbout}>{MAIN_MENU.about[rus]}</button></p>
                    <p><button className={`mobmenubtn${currentPage == 2 ? ' mobmenubtnactive' : ''}`} onClick={handleChangeLanguages}>{MAIN_MENU.languages[rus]}</button></p>
                    <p><button className={`mobmenubtn${currentPage == 1 ? ' mobmenubtnactive' : ''}`} onClick={handleChangePancyrillic}>{MAIN_MENU.panCyr[rus] + (rus ? langGroup?.name_rus : langGroup?.name_eng)}</button></p>
                    <p><button className={`mobmenubtn${currentPage == 4 ? ' mobmenubtnactive' : ''}`} onClick={handleChangeDefinitions}>{MAIN_MENU.definitions[rus]}</button></p>
                </AccordionDetails>
            </Accordion>
        </div>
        {(currentPage !== 3) && (currentPage !== 4) && <>
            <div className="mobcsswrap">
                <div className='mobilemenuwrapwhite'>
                    <Accordion sx={{ boxShadow: 0, p: 0, borderRadius: 0 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ p: 0, borderRadius: 0 }}>
                            <p className="mobmenutitle">{MAIN_MENU.select[rus]}</p>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                            <Langlist />
                        </AccordionDetails>
                    </Accordion>
                    <hr className="legenddivhoriz" />
                </div>
            </div>
        </>}
    </>)
};

export default MainMenu;